import React from "react";
import { Card, Tabs, Tab, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { isNull } from "lodash";
import HRSTLedger from "./HRSTLedger";
import HRLTLedger from "./HRLTLedger";
import HRSTLedgerReport from "./HRSTLedgerReport";
import HRLTLedgerReport from "./HRLTLedgerReport";
import LeaveTakenOrNot from "./LeaveTakenOrNot";

const HRLedgerTabs = (props) => {
    const permissions = JSON.parse(localStorage.getItem("permissions"));

    return (
        <>
            <Tabs
                defaultActiveKey={
                    !isNull(permissions) && permissions.some(p => p['sub_id'] === 79) ?
                    "ltAdvanceReport" :
                    !isNull(permissions) && permissions.some(p => p['sub_id'] === 80) ?
                    "stAdvanceReport" : ""}>
                {/* <Tab
                    eventKey="ltAdvance"
                    title="Long Term Advance Report"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 77) ? false : true}>
                    <HRLTLedger />
                </Tab>
                <Tab
                    eventKey="stAdvance"
                    title="Short Term Advance Report"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 78) ? false : true}>
                    <HRSTLedger />
                </Tab> */}
                <Tab
                    eventKey="ltAdvanceReport"
                    title="Long Term Advance Ledger"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 79) ? false : true}>
                    <HRLTLedgerReport />
                </Tab>
                <Tab
                    eventKey="stAdvanceReport"
                    title="Short Term Advance Ledger"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 80) ? false : true}>
                    <HRSTLedgerReport />
                </Tab>
                <Tab
                    eventKey="empLeaves"
                    title="Employee Accumulated Leaves"
                    unmountOnExit={true}
                    // disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 80) ? false : true}
                    >
                    <LeaveTakenOrNot />
                </Tab>
            </Tabs>

        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};
const mapStateToProps = (state, ownProps) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HRLedgerTabs);